<script setup>
import { computed, defineEmits, defineProps } from "vue";

const props = defineProps({
  title: String,
  contents: [String, Array],
  confirmText: String,
  closeText: String,
});

const isContentsArray = computed(() => Array.isArray(props.contents));

const emits = defineEmits(["submit"]);

function confirm() {
  emits("submit", true);
}

function close() {
  emits("submit", false);
}
</script>

<template>
  <div>
    <div class="modal-pop-bg on"></div>
    <div class="modal-pop on">
      <div class="popup-header">
        <h3 class="title" v-if="title" v-html="title"></h3>
        <h3 class="title" v-else>알림</h3>
        <button type="button" class="popup-close-btn" @click="close">
          닫기
        </button>
      </div>
      <div class="popup-body">
        <div class="text" v-if="isContentsArray">
          <span v-for="(data, idx) in contents" :key="idx" v-html="data"></span>
        </div>
        <div class="text" v-else>
          <span v-html="contents"></span>
        </div>
        <div class="modal-pop-button">
          <button type="button" @click="confirm">
            <span v-if="confirmText">{{ confirmText }}</span>
            <span v-else>확인</span>
          </button>
          <button type="button" class="btn-white" @click="close">
            <span v-if="closeText">{{ closeText }}</span>
            <span>취소</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-pop-bg {
  z-index: 2500;
}

.modal-pop {
  z-index: 3000;
}
</style>
